import Joi from 'joi'

export const ProfileModel = Joi.object().keys({
  gender: Joi.number().required(),
  height: Joi.number().required(),
  heightUnit: Joi.string().required(),
  weight: Joi.number().required(),
  weightUnit: Joi.string().required(),
  birthday: Joi.number().required(),
})
